export default function News() {
  const news = [
    {
      date: '2025.04.16',
      title: '【ゴールデンウィーク休業のお知らせ】',
    },
    {
      date: '2025.03.15',
      title: '「ウルトラファインバブル洗浄」の効果を比較検証！ナノバブル技術の可能性を探る',
    },
    {
      date: '2025.02.28',
      title: '未来の街づくりに選ばれる日本の技術—シンガポール展示会参加レポート',
    },
    {
      date: '2025.02.17',
      title: '大成建設株式会社発表｜高アルカリ性排水の中和処理を効率化！炭酸ガス使用量70%削減に成功',
    },
    {
      date: '2024.10.01',
      title: 'UFB DUAL技術とは？和菓子製造への革命的応用',
    },
  ];

  return (
    <section id="news" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-blue-50 to-transparent opacity-50"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <p className="text-blue-500 font-semibold text-sm uppercase tracking-wider mb-2">NEWS</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">ニュース・お知らせ</h2>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <ul className="divide-y divide-gray-200">
            {news.map((item, index) => (
              <li key={index} className="hover:bg-blue-50 transition-colors">
                <a href="#" className="block px-6 py-5">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <time className="text-sm font-semibold text-blue-500 whitespace-nowrap">
                      {item.date}
                    </time>
                    <p className="text-gray-900 flex-1">{item.title}</p>
                    <div className="w-6 h-6 flex items-center justify-center text-gray-400">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12 text-center">
          <a
            href="#contact"
            className="inline-block bg-blue-500 text-white px-8 py-3 rounded-full hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            一覧を見る
          </a>
        </div>
      </div>
    </section>
  );
}
